<template>
  <div id="map" class="google-map"></div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";
import EventBus from "@/services/EventBus.js";
import MapsMixin from '@/mixins/MapsMixin';

export default {
  mixins: [ MapsMixin ],

  props: {
    options: Object
  },

  mounted () {
    // MapsMixin mounted method will be call 1st and automatically,
    this.initializeMap("map");
  },
}
</script>

<style lang="scss" >
  @use "@/../scss/bmw/cx.scss";

  .customOverlayBox {
    background: cx.$bg-color-map-country-marker;
    border: 1px solid cx.$bd-color-map-country-marker;
    border-radius: 0.25rem;
    font-size: 1.3em;
    min-width: 40px;
    font-weight: 700;
    font-stretch: extra-condensed;
    padding: 0.25rem;
    color: cx.$fg-color-map-country-marker;
    position: absolute;
  }
</style>

<style scoped>

  .google-map {
    width: 100%;
    height: 100%;
  }

</style>
